import { InspectionTypeEnum } from '@authority-labs/enums';
import { BaseDto } from './base.dto';

/**
 * Editable inspection-duration bucket (frontend DTO mirroring the
 * `DurationBucket` entity). `maxQuantity = null`/`undefined` means unbounded.
 */
export class DurationBucket extends BaseDto {
  inspectionType?: InspectionTypeEnum | string;
  maxQuantity?: number | null;
  minutes?: number;
}
